const noop = () => {}

export type CreatePromiseReturn<T> = Promise<T> & {
  resolve: (value: PromiseLike<T> | T) => void
  reject: (reason?: any) => void
}

/**
 * 创建一个Promise对象
 * @param executor 执行器函数
 */
export function createPromise<T = any>(
  executor?: (
    resolve: (value: PromiseLike<T> | T) => void,
    reject: (reason?: any) => void,
  ) => void,
): CreatePromiseReturn<T> {
  let resolve: CreatePromiseReturn<T>['resolve'] = noop
  let reject: CreatePromiseReturn<T>['reject'] = noop

  const promise = new Promise<T>((_resolve, _reject) => {
    resolve = _resolve
    reject = _reject
    executor?.(_resolve, _reject)
  }) as CreatePromiseReturn<T>

  promise.resolve = resolve
  promise.reject = reject
  return promise
}
